import handleStep1 from './step1';
import handleStep2 from './step2';

export function handleStep() {
  if (document.getElementById('creation-step-1')) {
    handleStep1();
  }
  if (document.getElementById('creation-step-2')) {
    handleStep2();
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/index.js